import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import GeoJSON from "ol/format/GeoJSON";
import { getLength } from "ol/sphere";
import { translate } from "../../helpers/i18n";
const geoJsonFormat = new GeoJSON();
const meterFormat = new Intl.NumberFormat(undefined, {
    style: "unit",
    maximumFractionDigits: 2,
    unit: "meter",
});
const kilometerFormat = new Intl.NumberFormat(undefined, {
    style: "unit",
    maximumFractionDigits: 2,
    unit: "kilometer",
});
function formatLength(length) {
    const isKilometer = length > 1000;
    const format = isKilometer ? kilometerFormat : meterFormat;
    const amount = isKilometer ? length / 1000 : length;
    return format.format(amount);
}
function MeasureDistanceInfo({ feature }) {
    const geometry = useMemo(() => {
        var _a;
        if (((_a = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _a === void 0 ? void 0 : _a.type) !== "LineString") {
            return null;
        }
        return geoJsonFormat.readGeometry(feature.geometry, {
            featureProjection: "EPSG:3857",
            dataProjection: "EPSG:4326",
        });
    }, [feature === null || feature === void 0 ? void 0 : feature.geometry]);
    if (!geometry) {
        return null;
    }
    const length = getLength(geometry);
    const formattedValue = formatLength(length);
    return (_jsxs("div", { className: "ms3-measure-distance", children: [translate("ui.measure-distance.measurement"), ": ", formattedValue] }));
}
export default MeasureDistanceInfo;
